export const rewards = {
    "entitled_first_month_50_off_campaign": "Congrats! You've earned a 50 ILS discount on your first month",
    "entitled_first_month_30_off_campaign": "Congrats! You've earned a 30 ILS discount on your first month"
};
